import React, { useState, useEffect } from 'react';
import Impds from './Impds';
import { CircularProgress } from '@mui/material';

const ImpdsInterface = () => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [initialMoval, setInitialMoval] = useState(null);
  const [initialYeval, setInitialYeval] = useState(null);
  const [trans, setTrans] = useState('REGULAR/@/1,2,7,98');
  const [availableMonths, setAvailableMonths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showImpds, setShowImpds] = useState(false);
  const [homeState, setHomeState] = useState('');
  const [stateNameEn, setStateNameEn] = useState('');

  useEffect(() => {
    fetchInitialData();
  }, []);

  useEffect(() => {
    if (initialMoval !== null && initialYeval !== null) {
      getSameMonthYearCommOfRo();
    }
  }, [month, initialMoval, initialYeval]); 

  const fetchInitialData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL_SIDE}/api/impds/initial-data`);
      const data = await response.json();
      setMonth(data.month.toString());
      setInitialMoval(data.month);
      setInitialYeval(data.year);
      setYear(data.year.toString());
      setHomeState(data.homeState);
      setStateNameEn(data.stateNameEn);
      setLoading(false);
      setShowImpds(true);
    } catch (error) {
      console.error('Error fetching initial data:', error);
      setLoading(false);
    }
  };

  const getSameMonthYearCommOfRo = () => {
    const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    const moval = initialMoval;
    const yeval = initialYeval; 
    let monthsToShow = [];
    if (moval === 1) {
      monthsToShow = [9, 10, 11, 12, 1];
    } else if (moval === 2) {
      monthsToShow = [10, 11, 12, 1, 2];
    } else if (moval > 2 && moval <= 12) {
      monthsToShow = [moval - 2, moval - 1, moval];
    }
    const formattedMonths = monthsToShow.map(m => ({
      value: m,
      text: monthNames[m - 1]
    }));
    setAvailableMonths(formattedMonths);
    const currentMonth = parseInt(month);
    let newYear = yeval;
    if (moval === 1) {
      if (moval !== currentMonth) {
        newYear = yeval - 1;
      }
    } else if (moval === 2) {
      if (currentMonth > 2) {
        newYear = yeval - 1;
      }
    }
    setYear(newYear.toString());
  };

  const handleMonthChange = (e) => {
    setMonth(e.target.value);
  };

  const handleTransChange = (e) => {
    setTrans(e.target.value);
  };

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20px" }}>
      <CircularProgress/>
    </div>;
  }

  return (
    <div style={{ paddingBottom: '70px' }}>
      <table border="1" style={{ borderCollapse: 'collapse', margin: '20px auto', width: '60%' }}>
        <tbody>
          <tr bgcolor="orange">
            <td align="center" colSpan="10">
              <div align="center"><b>ONORC STATUS</b></div>
            </td>
          </tr>
          <tr bgcolor="lightgreen">
            <td align="center" colSpan="3">
              <font size="3"><b>Transaction Month :</b></font>
              <select
                name="month"
                id="month"
                value={month}
                onChange={handleMonthChange}
              >
                {availableMonths.map(m => (
                  <option key={m.value} value={m.value}>{m.text}</option>
                ))}
              </select>
            </td>
            <td align="center" colSpan="3">
              <font size="3"><b>Transaction Year :</b></font>
            </td>
            <td id="yearval"><b>{year}</b></td>
            <td>
              <input type="hidden" name="year" id="year" value={year} />
            </td>
            <td>Transaction Type</td>
            <td>
              <select name="trans" id="trans" value={trans} onChange={handleTransChange}>
                <option value="REGULAR/@/1,2,7,98">REGULAR</option>
                <option value="PMGKAY/@/95,96">PMGKAY</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
      {showImpds && (
        <Impds
          month={month}
          year={year}
          trans={trans}
          homeState={homeState}
          stateNameEn={stateNameEn}
        />
      )}
    </div>
  );
};

export default ImpdsInterface;
